<template>
  <b-container>
    <b-row>
      <b-col>
        <h5>
          กรอกรหัสผ่านเพื่อยืนยันการลบ
        </h5>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-input
          v-model="password"
          type="password"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: "ConfirmModal",
    props: {
        value: {
            type: String,
            default: ''
        }
    },
    computed: {
        password: {
            get() {
                return this.value
            },
             set(value) {
                 this.$emit('input', value)
             }
        }
    }
  }
</script>

<style scoped>

</style>
